import type { PermitApplicationReviewer, PermitReviewerDecision } from "@/api/permit_applications";

const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

function csrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
}

export async function addPermitApplicationReviewer(
  municipalityId: number,
  applicationId: number,
  userId: number,
): Promise<PermitApplicationReviewer> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/permit_applications/${applicationId}/reviewers`,
    {
      method: "POST",
      credentials: "include",
      headers: { ...jsonHeaders, "X-CSRF-Token": csrfToken() },
      body: JSON.stringify({ permit_application_reviewer: { user_id: userId } }),
    },
  );
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.errors?.join(", ") ?? "Failed to add reviewer");
  }
  return response.json();
}

export async function removePermitApplicationReviewer(
  municipalityId: number,
  applicationId: number,
  userId: number,
): Promise<void> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/permit_applications/${applicationId}/reviewers/${userId}`,
    {
      method: "DELETE",
      credentials: "include",
      headers: { "X-CSRF-Token": csrfToken() },
    },
  );
  if (!response.ok) throw new Error("Failed to remove reviewer");
}

export async function updatePermitApplicationReviewer(
  municipalityId: number,
  applicationId: number,
  userId: number,
  payload: {
    role_label?: string | null;
    notes?: string | null;
    decision?: PermitReviewerDecision | null;
  },
): Promise<PermitApplicationReviewer> {
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/permit_applications/${applicationId}/reviewers/${userId}`,
    {
      method: "PATCH",
      credentials: "include",
      headers: { ...jsonHeaders, "X-CSRF-Token": csrfToken() },
      body: JSON.stringify({ permit_application_reviewer: payload }),
    },
  );
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.errors?.join(", ") ?? "Failed to update reviewer");
  }
  return response.json();
}
